export default __webpack_public_path__ + "static/media/ic_info_blue.eb600a69.svg";